import React, { useContext, useEffect, useState } from 'react';
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';
// import AuthSimpleLayout from './AuthSimpleLayout';
import is from 'is_js';
import MainLayout from './MainLayout';
import SettingsToggle from 'components/settings-panel/SettingsToggle';
import SettingsPanel from 'components/settings-panel/SettingsPanel';
import axios from '../api/axios';

import { toast, ToastContainer } from 'react-toastify';
import { CloseButton } from 'components/common/Toast';

import AppContext from 'context/Context';

import ErrorLayout from './ErrorLayout';
import Error404 from 'components/errors/Error404';
import Error500 from 'components/errors/Error500';
// import Profile from 'components/pages/user/profile/Profile';

import Profile from 'pages/application/profile';
import Dashboard from 'pages/main/dashboard';
import VehicleTracking from 'pages/main/vehicle-tracking';
import Employee from 'pages/master/employee';
import EmployeePedicab from 'pages/master/employeePedicab';
import Vehicle from 'pages/master/vehicle';
import VehicleRoute from 'pages/master/route';
import VehicleRouteMap from 'pages/master/route-map';
import School from 'pages/master/school';
import Student from 'pages/master/students';
import AppAccount from 'pages/master/app-account/';
import Article from 'pages/master/article/';
import ImageSlider from 'pages/master/image-slider';
import StudentRegistration from 'pages/operational/StudentRegistration';
import StudentReport from 'pages/operational/student-report';
import BusReport from 'pages/operational/bus-report';
import DriverReport from 'pages/operational/driver-report';
import Complaint from 'pages/operational/complaint';
import ComplaintMessage from 'pages/operational/complaint-message';
import ChattingMember from 'pages/operational/chatting-user';
import BusReservation from 'pages/operational/bus-reservation';

import Users from 'pages/application/users';
import Roles from 'pages/application/roles';
import Menus from 'pages/application/menus';

import CardLogin from 'components/authentication/card/Login';

const Layout = () => {
    const HTMLClassList = document.getElementsByTagName('html')[0].classList;
    const {
      config: { navbarPosition }
    } = useContext(AppContext);
    const navigate = useNavigate();

    // Const Variable
    const URL_NAVIGATION = '/apps/navigation';
  
    // state Variable
    const [menus, setMenus] = useState([]);
    const [accessUser, setAccessUser] = useState(false);
  
    useEffect(() => {
      if (is.windows()) {
        HTMLClassList.add('windows');
      }
      if (is.chrome()) {
        HTMLClassList.add('chrome');
      }
      if (is.firefox()) {
        HTMLClassList.add('firefox');
      }
      if (is.safari()) {
        HTMLClassList.add('safari');
      }
    }, [HTMLClassList]);
  
    useEffect(() => {
      if (navbarPosition === 'double-top') {
        HTMLClassList.add('double-top-nav-layout');
      }
      return () => HTMLClassList.remove('double-top-nav-layout');
    }, [HTMLClassList, navbarPosition]);
  
    useEffect(() => {
      const item = JSON.parse(localStorage.getItem('accessUser'));
      if (item) {
        setAccessUser(item);
        getMenus(item.token, item.role);
      } else {
        navigate('login');
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getMenus = async (token, roleUser) => {
      const bearerToken = accessUser.token ? accessUser.token : token
      const role = accessUser.role ? accessUser.role : roleUser;
      try {
        const response = await axios.get(URL_NAVIGATION + '?role=' + role, {
          headers: {
            'Authorization': `Bearer ${bearerToken}`
          }
        });
        setMenus(response?.data);
      } catch (err) {
        if (!err?.response) {
          toast.error('No Server Response');
        } else if (err?.response.status === 400) {
          toast.error(err?.response.data.message);
        } else if (err?.response.status === 401) {
          toast.error(err?.response.data.message);
          localStorage.removeItem('accessUser');
          navigate('/login');
        }
      }
    }

    return (
      <>
          <Routes>
              <Route path="login" element={<CardLogin />} />

              <Route element={<ErrorLayout />}>
                  <Route path="errors/404" element={<Error404 />} />
                  <Route path="errors/500" element={<Error500 />} />
              </Route>

              <Route element={<MainLayout menus = {menus} accessUser = {accessUser} />}>
                  <Route path="/" element={<Dashboard />} />
                  <Route path="/main/lacak-kendaraan" element={<VehicleTracking />} />
                  <Route path="/master/pengemudi" element={<Employee />} />
                  <Route path="/master/pengemudi-becak" element={<EmployeePedicab />} />
                  <Route path="/master/kendaraan" element={<Vehicle />} />
                  <Route path="/master/rute" element={<VehicleRoute />} />
                  <Route path="/master/rute-map" element={<VehicleRouteMap />} />
                  <Route path="/master/siswa" element={<Student />} />
                  <Route path="/master/sekolah" element={<School />} />
                  <Route path="/master/akun" element={<AppAccount />} />
                  <Route path="/master/artikel" element={<Article />} />
                  <Route path="/master/gambar-slider" element={<ImageSlider />} />
                  <Route path="/operasional/pendaftaran-siswa" element={<StudentRegistration />} />
                  <Route path="/operasional/reservasi-bus" element={<BusReservation />} />
                  <Route path="/operasional/laporan-bus" element={<BusReport />} />
                  <Route path="/operasional/laporan-sopir" element={<DriverReport />} />
                  <Route path="/operasional/laporan" element={<StudentReport />} />
                  <Route path="/operasional/complaint" element={<Complaint />} />
                  <Route path="/operasional/complaint-message/:intid/:token" element={<ComplaintMessage />} />
                  <Route path="/operasional/chatting-member" element={<ChattingMember />} />
                  <Route path="user/profile" element={<Profile />} />
                  <Route path="application/users" element={<Users />} />
                  <Route path="application/roles" element={<Roles />} />
                  <Route path="application/menus" element={<Menus />} />
              </Route>
              
              <Route path="*" element={<Navigate to="/errors/404" replace />} />
          </Routes>
          <SettingsToggle />
          <SettingsPanel />
          <ToastContainer
              closeButton={CloseButton}
              icon={false}
              position={toast.POSITION.TOP_CENTER}
          />
      </>
    );
}

export default Layout;